import {
  PayeeRequirement,
  RequirementStatus,
  SignatureRequest,
  SignerStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * TODO(v3-verify): see `selectorIsRequirementReadyToSignAsPayee` — matching
 * signers by `role === "Payer"` / `"Payee"` assumes the BE preserves v1's
 * `SignerRole` string convention; confirm at runtime.
 */
export const selectorIsRequirementReadyToSignAsPayer = (
  requirement: PayeeRequirement,
  document?: SignatureRequest
) => {
  const requiresPayerSignature = document?.signers?.find(
    signer => signer.role === "Payer"
  );

  const payeeSigner = document?.signers?.find(
    signer => signer.role === "Payee"
  );
  const isSignedByPayee = payeeSigner?.status === SignerStatus.SIGNED;

  return (
    requirement.dataSourceStatus !== RequirementStatus.COMPLETED &&
    isSignedByPayee &&
    !!requiresPayerSignature
  );
};
